import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const ModCoverageSelectUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{width: "100%", height: "100%", padding:  "1rem"}}>
        <div
          style={{display: "flex", justifyContent: "space-between"}}>
          
          <div
            style={{fontWeight: "bold", fontSize: "18px"}}>
            {props.languageUX === "en" ? "List of certified rights" : "รายการสิทธิที่รับรอง"}
          </div>
          <div
            style={{margin: "-0rem 0 -0.25rem"}}>
            {props.closeIcon}
          </div>
        </div>
        <div
          className="ui divider">
          
        </div>
        <Table
          data={props.patientCoverageList}
          getTrProps={props.onSelectedPatientCoverage}
          headers="Coverage Name, Payer Name, Service Type, Priority, Start Date,End Date"
          keys="coverage_name,payer_name,service_type_name,priority,start_date,stop_date"
          minRows={10}
          showPagination={false}
          style={{height: "400px"}}
          widths=",,150,150,200,200">
        </Table>
        <div
          style={{display: "flex", padding: "10px 0px", justifyContent: "flex-end"}}>
          
          <Button
            color="green"
            disabled={!props.selectedPatientCoverage}
            onClick={props.onClickSelectedPatientCoverage}
            size="small">
            {props.languageUX === "en" ? "choose" : "เลือก"}
          </Button>
        </div>
      </div>
    )
}


export default ModCoverageSelectUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding:  \"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"10px 0px\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.patientCoverageList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onSelectedPatientCoverage"
        },
        "headers": {
          "type": "value",
          "value": "Coverage Name, Payer Name, Service Type, Priority, Start Date,End Date"
        },
        "keys": {
          "type": "value",
          "value": "coverage_name,payer_name,service_type_name,priority,start_date,stop_date"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"400px\"}"
        },
        "widths": {
          "type": "value",
          "value": ",,150,150,200,200"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "choose"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedPatientCoverage"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickSelectedPatientCoverage"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการสิทธิที่รับรอง",
          "valueEN": "List of certified rights"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"18px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.closeIcon"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"-0rem 0 -0.25rem\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        }
      },
      "seq": 3,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 65,
  "isMounted": true,
  "memo": false,
  "name": "ModCoverageSelectUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
